import React from "react";

const LoadingScreen = ({ message = "Loading deals..." }) => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
            <div className="text-center">
                <div className="animate-spin h-16 w-16 border-4 border-blue-500 border-t-transparent rounded-full mx-auto mb-6"></div>
                <p className="text-xl font-medium text-gray-700">{message}</p>
            </div>
        </div>
    );
};

export default LoadingScreen; 